import {
  Button,
  Dialog,
  DialogTitle,
  Alert,
  AlertTitle,
  Paper,
  Radio,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useState } from "react";

interface Props {
  openModal: boolean;
  handleClose: () => void;
}

type RemovalOption = {
  value: "switch" | "remove";
  title: string;
  description: string;
  recommended?: boolean;
};

const options: RemovalOption[] = [
  {
    value: "switch",
    title: "Switch to a different config",
    description:
      "Replace it in one step: a new access check runs on the replacement before the old config is deactivated.",
    recommended: true,
  },
  {
    value: "remove",
    title: "Remove completely",
    description:
      "The row is kept, want_run is set to false and status to inactive; the raw_data table and history are preserved. It can be reactivated later.",
  },
];

const RemovingMapModal = ({ openModal, handleClose }: Props) => {
  const [selected, setSelected] = useState<RemovalOption["value"]>("switch");

  return (
    <>
      <Dialog
        open={openModal}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper>
          <Box
            sx={{
              padding: "16px 24px 20px 24px",
            }}
          >
            <DialogTitle sx={{ padding: "0px 0px 5px 0px" }}>
              Remove IA_acid_none_day?{" "}
              <span style={{ color: "#00000099" }}>(19)</span>
            </DialogTitle>
            <Typography variant="body2" color="#00000061">
              Awin Sport UK (4567) ● <span>IncomeAccess</span>{" "}
            </Typography>
          </Box>

          <Box sx={{ padding: "10px 24px ", width: "100%" }}>
            {options.map((option) => {
              const isSelected = selected === option.value;

              return (
                <Paper
                  key={option.value}
                  variant="outlined"
                  onClick={() => setSelected(option.value)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: "none",
                    cursor: "pointer",
                    transition: "all 0.2s ease",

                    borderColor: isSelected ? "#9C27B080" : "#0000001F",

                    bgcolor: isSelected ? "#9C27B014" : "#fff",

                    "&:hover": {
                      borderColor:
                        option.value === "switch" ? "#ba68c8" : "#0000001F",
                    },
                  }}
                >
                  <Radio
                    checked={isSelected}
                    value={option.value}
                    onChange={() => setSelected(option.value)}
                    sx={{
                      p: 0,
                      mt: 0.4,
                      color:
                        option.value === "switch" ? "#9C27B0" : "#00000099",

                      "&.Mui-checked": {
                        color: "#9C27B0",
                      },
                    }}
                  />

                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#000000DE",
                        }}
                      >
                        {option.title}
                      </Typography>

                      {option.recommended && (
                        <Typography
                          sx={{
                            fontSize: 12,
                            color: "#2E7D32",
                          }}
                        >
                          Recommended!
                        </Typography>
                      )}
                    </Box>

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#00000099",
                      }}
                    >
                      {option.description}
                    </Typography>
                  </Box>
                </Paper>
              );
            })}

            <Alert
              severity="warning"
              variant="outlined"
              sx={{
                mt: 1,
                borderRadius: 2,
                borderColor: "#ED6C0280",
                bgcolor: "#FFF4E5",
                padding: "8px",

                "& .MuiAlert-icon": {
                  color: "#E65100",
                },

                "& .MuiAlert-message": {
                  width: "100%",
                  padding: 0,
                },
              }}
            >
              <AlertTitle
                sx={{
                  fontWeight: 500,
                  color: "#E65100",
                  fontSize: 14,
                  mb: 0.5,
                }}
              >
                PLEASE NOTE
              </AlertTitle>

              <Typography
                sx={{
                  color: "#E65100",
                  fontSize: 14,
                }}
              >
                2 active Unifier maps read from raw_data_172 and will stop
                receiving new data: ia_brand_per_day_before_TotalBets/Hands,
                ia_user_per_day_default.
              </Typography>
            </Alert>
          </Box>

          <Stack
            flexDirection={"row"}
            justifyContent={"end"}
            gap={1}
            sx={{
              padding: "16px 24px 20px 24px",
            }}
          >
            <Button variant="text" color="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              continue
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default RemovingMapModal;
